import api from './api';

export const usersApi = {
  discover: async (query, page = 1, options = {}) => {
    const response = await api.getAuth('/users/discover', {
      ...options,
      params: { page, size: 20, ...(query ? { q: query } : {}) },
    });
    return response.data;
  },
  recordMemberEvents: async (events, options = {}) => {
    await api.postAuth('/search/discovery/events/batch', { events }, options);
  },
  getUser: async (nickname, options = {}) => {
    const response = await api.get(`/users/${encodeURIComponent(nickname)}`, {
      ...options,
      suppressGlobalError: true,
    });
    return response.data;
  },
  getUserById: async (userId, { signal } = {}) => {
    const response = await api.get(`/users/by-id/${userId}`, {
      suppressGlobalError: true,
      signal,
    });
    return response.data;
  },
  getUserReviews: async (nickname) => {
    const response = await api.get(`/users/${encodeURIComponent(nickname)}/reviews`);
    return response.data;
  },

  getUserLists: async (nickname) => {
    const response = await api.get(`/users/${encodeURIComponent(nickname)}/lists`);
    return response.data;
  },

  getUserComments: async (nickname) => {
    const response = await api.get(`/users/${encodeURIComponent(nickname)}/comments`);
    return response.data;
  },

  getUserBookmarks: async (nickname) => {
    const response = await api.get(`/users/${encodeURIComponent(nickname)}/saved`);
    return response.data;
  },

  getFollowStatus: async (userId, options = {}) => {
    const response = await api.getAuth(`/users/${userId}/follow`, {
      ...options,
      suppressGlobalError: true,
    });
    return response.data;
  },

  getFollowers: async (nickname, options = {}) => {
    const response = await api.getAuth(`/users/${encodeURIComponent(nickname)}/followers`, options);
    return response.data;
  },

  getFollowing: async (nickname, options = {}) => {
    const response = await api.getAuth(`/users/${encodeURIComponent(nickname)}/following`, options);
    return response.data;
  },

  followUser: async (userId, options = {}) => {
    const response = await api.postAuth(`/users/${userId}/follow`, {}, options);
    return response.data;
  },

  unfollowUser: async (userId, options = {}) => {
    const response = await api.deleteAuth(`/users/${userId}/follow`, options);
    return response.data;
  },
};
